import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function ContactSection() {
  const { ref, isVisible } = useScrollReveal(0.15);

  return (
    <section id="contact" className="w-full py-16 md:py-24 px-4 md:px-6 bg-background-50">
      <div className="max-w-[960px] mx-auto" ref={ref}>
        <div className={`text-center mb-10 md:mb-14 transition-all duration-700 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
        }`}>
          <span className="inline-block text-xs font-medium text-primary-600 bg-primary-100/60 px-3 py-1 rounded-full mb-3">
            互动通道
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            联系我们
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            欢迎投稿、商务合作或提供宝贵建议，期待与您的交流
          </p>
        </div>

        <div className={`bg-background-100 border border-background-200/70 rounded-xl p-6 md:p-10 transition-all duration-700 delay-100 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center group">
              <div className="w-14 h-14 rounded-2xl bg-primary-100 flex items-center justify-center mx-auto mb-4 group-hover:bg-primary-200 transition-colors">
                <i className="ri-mail-line text-2xl text-primary-600"></i>
              </div>
              <h3 className="text-sm font-heading font-bold text-foreground-900 mb-1.5">投稿邮箱</h3>
              <p className="text-sm text-foreground-500">tougao@heiliao718.com</p>
              <p className="text-xs text-foreground-400 mt-1">48 小时内回复</p>
            </div>
            <div className="text-center group">
              <div className="w-14 h-14 rounded-2xl bg-accent-100 flex items-center justify-center mx-auto mb-4 group-hover:bg-accent-200 transition-colors">
                <i className="ri-hand-heart-line text-2xl text-accent-600"></i>
              </div>
              <h3 className="text-sm font-heading font-bold text-foreground-900 mb-1.5">商务合作</h3>
              <p className="text-sm text-foreground-500">hezuo@heiliao718.com</p>
              <p className="text-xs text-foreground-400 mt-1">工作日 24h 响应</p>
            </div>
            <div className="text-center group">
              <div className="w-14 h-14 rounded-2xl bg-secondary-100 flex items-center justify-center mx-auto mb-4 group-hover:bg-secondary-200 transition-colors">
                <i className="ri-wechat-line text-2xl text-secondary-600"></i>
              </div>
              <h3 className="text-sm font-heading font-bold text-foreground-900 mb-1.5">官方微信</h3>
              <p className="text-sm text-foreground-500">黑料718</p>
              <p className="text-xs text-foreground-400 mt-1">工作日 9:00-18:00</p>
            </div>
          </div>

          <div className="mt-10 pt-8 border-t border-background-200/50">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 max-w-[720px] mx-auto">
              {[
                { icon: 'ri-article-line', label: '原创投稿', desc: '分享您的正能量故事' },
                { icon: 'ri-advertisement-line', label: '广告合作', desc: '品牌精准触达正能量读者' },
                { icon: 'ri-user-star-line', label: '内容共创', desc: '联合策划深度专题内容' },
              ].map((item, i) => (
                <a
                  key={i}
                  href="#contact"
                  className="flex items-center gap-3 p-4 rounded-xl bg-background-200/40 hover:bg-background-200/70 transition-colors cursor-pointer"
                >
                  <div className="w-10 h-10 rounded-lg bg-background-50 flex items-center justify-center flex-shrink-0">
                    <i className={`${item.icon} text-lg text-foreground-600`}></i>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-foreground-900">{item.label}</p>
                    <p className="text-xs text-foreground-500">{item.desc}</p>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}